import CurrentlyBuilding from "../Components/CurrentlyBuilding";
import ElevateAppBar from "../Components/Header";

const Contact = () => {
    return ( 
        <div>
            <ElevateAppBar></ElevateAppBar>
            <CurrentlyBuilding></CurrentlyBuilding>
        </div>
     );
}
 
export default Contact;